import React, {useContext} from 'react';
import { List, ListItem, ListItemButton, ListItemText, styled, useTheme } from '@mui/material';
import { useAbility } from '@casl/react';
import {Link} from 'react-router-dom';
import UserContext from '@lib/contexts/userContext';
import { Roles } from '@lib/constants';
import { AbilityContext, Subjects } from '@lib/permissions';

const NavMenu = ({ showHome = false, listStyles = {}, onLinkClick = null }) => {
  const { isLoggedIn, signOut, isSSO, hasRole } = useContext(UserContext);

  const ability = useAbility(AbilityContext);

  const NavHeader = ({ text }) => (
    <ListItem
      sx={{
        paddingLeft: '16px',
        backgroundColor: 'ilblue.main',
      }}
    >
      <ListItemText
        primary={text}
        sx={{
          '& .MuiListItemText-primary': {
            color: '#fff',
            fontWeight: 'bold',
            fontFamily: 'Montserrat',
            lineHeight: 1.5
          },
        }}
      />
    </ListItem>
  );

  const NavLink = ({ to, text, onClick, disabled = false, sx = {} }) => (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        to={to || ''}
        disabled={disabled}
        onClick={() => {
          if (onClick) onClick();
          if (onLinkClick) onLinkClick();
        }}
        sx={{ color: 'ilblue.main', ...sx }}
      >
        <ListItemText primary={text} />
      </ListItemButton>
    </ListItem>
  );

  const NavList = styled(List)(listStyles);

  const eventsManagerEnabled = process.env.ENV !== 'production';

  return (
    <nav>
      <NavList dense={true} variant="nav" className={'nav'} sx={{ paddingTop: 0, paddingBottom: 0 }}>
        {hasRole(Roles.USER) && (
          <>
            {showHome && <NavLink to={'/'} text={'Home'} />}
          </>
        )}
        {(isLoggedIn() && hasRole(Roles.USER)) && (
          <>
            <NavLink to="/member/profile" text="My Profile"/>
            <NavLink to="/member/activities" text="My Activities"/>
            <NavLink to="/checkin" text="Check In"/>
            {ability.can('view', Subjects.PAGE_CHANGE_PASSWORD) && (
              <NavLink to="/member/password" text="Change Password"/>
            )}
          </>
        )}
        {(isLoggedIn() && hasRole([Roles.STAFF, Roles.ADMIN, Roles.SUPER_ADMIN])) && (
          <>
            {eventsManagerEnabled && (
              <>
                <NavHeader
                  text="Events Manager"
                />
                <List sx={{ marginLeft: '8px', paddingTop: 0 }}>
                  {ability.can('view', Subjects.PAGE_EVENTS) && (
                    <NavLink to="/events" text="Events" />
                  )}
                  {ability.can('view', Subjects.PAGE_UPCOMING_SESSIONS) && (
                    <NavLink to="/sessions/upcoming" text="Sessions - Upcoming" />
                  )}
                  {ability.can('view', Subjects.PAGE_PAST_SESSIONS) && (
                    <NavLink to="/sessions/past" text="Sessions - Past" />
                  )}
                </List>
              </>
            )}
            {ability.can('view', Subjects.PAGE_PROFILE) && (
              <NavLink to="/member/profile" text="My Profile"/>
            )}
            {ability.can('view', Subjects.PAGE_CHANGE_PASSWORD) && (
              <NavLink to="/member/password" text="Change Password"/>
            )}
          </>
        )}
        {!isLoggedIn() && (
          <>
            <NavLink to="/signup" text="Sign Up" />
            <NavLink to="/login" text="Log In" />
            <NavLink to="/checkin" text="Check In" />
          </>
        )}
      </NavList>
      {/*<Divider className={'nav'} />*/}
      {isLoggedIn() && (
        <NavList variant="nav" dense={true} className={'nav'}>
          <NavLink to="/?signout=true" text="Sign Out"/>
        </NavList>
      )}
    </nav>
  );
};

export default NavMenu;
